import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import { handleChangeEvent, handlePatch } from '../../../utils/AxiosUtil';
import * as util from '../../../utils/Util';
import ErrorAwareBankAccountField from '../../common/inputfields/ErrorAwareBankAccountField';

class ModifyBankAccountNumber extends Component {

    state = {
        bankAccountNumber: this.props.row.bankAccountNumber,
        validFrom: this.props.row.validFrom ? new Date(this.props.row.validFrom) : null,
        validUntil: this.props.row.validUntil ? new Date(this.props.row.validUntil) : null,
        errors: new Map()
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/bankaccountnumber';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "bankAccountNumber": util.trimSpaces(this.state.bankAccountNumber),
            "validFrom": this.state.validFrom
        };
        await handlePatch(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <TextField
                            disabled
                            fullWidth
                            variant="outlined"
                            id="partner"
                            label="Partner"
                            value={this.props.row.partnerName} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareBankAccountField
                            name="bankAccountNumber"
                            label="Bankszámlaszám"
                            errors={this.state.errors}
                            prevValue={this.props.row.bankAccountNumber}
                            value={this.state.bankAccountNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                        Mégse
                    </Button>
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Mentés
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyBankAccountNumber);
